import { Component, type ReactNode } from 'react';

/**
 * Last line of defence: an error while drawing the page shows a message (with the error text and a
 * reload button) instead of an empty screen. Unsaved changes are kept in the local journal.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('Smart Cabinet Studio: greška pri prikazu', error);
  }

  render() {
    const e = this.state.error;
    if (!e) return this.props.children;
    return (
      <div style={{ padding: 32, maxWidth: 640, margin: '40px auto', fontFamily: 'system-ui, sans-serif' }} role="alert">
        <h2>Nešto je pošlo po zlu pri prikazu</h2>
        <p>Izmjene koje nisu snimljene na server čuvaju se lokalno i nude se pri ponovnom otvaranju projekta.</p>
        <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, opacity: 0.8 }}>{e.message}</pre>
        <button className="btn primary" onClick={() => location.reload()}>
          Ponovo učitaj
        </button>
      </div>
    );
  }
}
